import {BaseModel} from '../base/BaseModel.js';
import {RegexUtils} from '../../utils/RegexUtils';
import {UnitConverter} from '../../utils/UnitConverter';

/**
 * @class FieldModel
 * @extends BaseModel
 *
 * @property {object} attributes
 * @property {string<UUID>} attributes.uuid
 * @property {string<UUID>} attributes.farmUuid
 * @property {object} attributes.geometry
 * @property {string} attributes.name
 * @property {number} attributes.heading
 */
export class FieldModel extends BaseModel {

    initialize () {

        this.microservice = 'farms';
        this.resource = 'fields';
    }

    get defaults () {

        return {
            name: undefined,
            farmUuid: undefined,
            area: 0,
            heading: undefined,
            soilTextureUuid: undefined,
            soilTaxonomyUuid: undefined
        };
    }

    parse (data) {

        if (data.heading) {
            data.heading = Math.round(UnitConverter.localToSi(data.heading, 'DEGREE'));
        }

        if (!data.soilTextureUuid) {
            data.soilTextureUuid = undefined;
        }

        if (!data.soilTaxonomyUuid) {
            data.soilTaxonomyUuid = undefined;
        }

        return data;
    }

    toJSON () {

        let obj = _.clone(this.attributes);

        if (obj.heading) {
            obj.heading = UnitConverter.siToLocal(obj.heading, 'DEGREE');
        }

        return obj;
    }


    validateProperty (property, attributes) {

        if (property === 'name') {

            attributes.name = _.trim(attributes.name);
            return FieldModel.validateName(attributes.name);
        }

        if (property === 'heading') {

            return FieldModel.validateHeading(attributes);
        }
    }


    static validateName (name) {

        if (!name) {

            return {
                property: 'name',
                message: __('FIELD_NAME_EMPTY')
            };
        }

        let re = RegexUtils.getFieldNameRegex();

        if(!re.test(name)) {

            return {
                property: 'name',
                message: __('FIELD_NAME_INVALID_CHAR')
            };
        }

        let max = 64;

        if(name.length > max) {

            return {
                property: 'name',
                message: __('FIELD_NAME_INVALID_LENGTH_MAX')
            };
        }
    }



    static validateHeading (attr) {

        let min = 0;
        let max = 180;

        if (!attr.heading && min !== 0) {

            return {
                property: 'heading',
                message: __('HEADING_VALUE_EMPTY')
            };
        }

        if (typeof attr.heading !== 'number') {

            return {
                property: 'heading',
                message: __('HEADING_VALUE_INVALID')
            };
        }

        if(attr.heading !== parseFloat(attr.heading)) {

            return {
                property: 'heading',
                message: __('HEADING_VALUE_INVALID')
            };
        }

        if(attr.heading < min) {

            return {
                property: 'heading',
                message: __('HEADING_VALUE_LOW')
            };
        }

        if (attr.heading > max) {

            return {
                property: 'heading',
                message: __('HEADING_VALUE_HIGH')
            };
        }
    }

    static parseGQL(data) {

        const {
            uuid,
            name,
            area,
            heading,
            geometry,
            boundarySvg,
            farm,
            soilTexture,
            soilTaxonomy,
        } = data;

        return {
            uuid,
            name,
            area,
            heading,
            geometry,
            boundarySvg,
            farmUuid: farm && farm.uuid || undefined,
            soilTextureUuid: soilTexture && soilTexture.uuid || undefined,
            soilTaxonomyUuid: soilTaxonomy && soilTaxonomy.uuid || undefined,
        };
    }

}



// WEBPACK FOOTER //
// ./shared/model/farms/FieldModel.js